import React from "react";

const Logo = ({ clSVG, clBoundry, clLetter }) => {
  return (
    <svg
      width="180"
      height="180"
      viewBox="0 0 180 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clSVG}
    >
      <path
        className={clBoundry}
        d="M15.5577 47.0207L90 4.04145L164.442 47.0207V132.979L90 175.959L15.5577 132.979V47.0207Z"
        // stroke="#0B0739"
        strokeWidth="7"
        strokeDasharray={520}
      />
      <path
        className={clLetter}
        // stroke="#0B0739"
        strokeWidth="7"
        strokeDasharray={520}
        d="M77.4086 127.847C71.1356 127.847 66.3416 126.521 63.0266 123.869C59.7116 121.166 57.7226 117.06 57.0596 111.552C56.9066 110.226 57.1871 109.206 57.9011 108.492C58.6151 107.727 59.6606 107.345 61.0376 107.345C62.3126 107.345 63.2561 107.676 63.8681 108.34C64.5311 109.002 64.9646 109.997 65.1686 111.323C65.6276 114.485 66.7751 116.703 68.6111 117.978C70.4981 119.202 73.4306 119.814 77.4086 119.814H102.501C107.244 119.814 110.508 118.922 112.293 117.137C114.078 115.352 114.97 112.088 114.97 107.345C114.97 102.551 114.078 99.2615 112.293 97.4765C110.508 95.6915 107.244 94.799 102.501 94.799H77.7146C71.0846 94.799 66.1376 93.218 62.8736 90.056C59.6606 86.843 58.0541 81.9215 58.0541 75.2915C58.0541 68.5085 59.6606 63.536 62.8736 60.374C66.0866 57.161 71.0336 55.5545 77.7146 55.5545H101.736C113.262 55.5545 119.662 60.6545 120.937 70.8545C121.141 72.1805 120.861 73.226 120.096 73.991C119.382 74.705 118.362 75.062 117.036 75.062C115.761 75.062 114.792 74.7305 114.129 74.0675C113.517 73.4045 113.083 72.4355 112.828 71.1605C112.471 68.3045 111.426 66.341 109.692 65.27C108.009 64.148 105.357 63.587 101.736 63.587H77.7146C73.2776 63.587 70.2176 64.403 68.5346 66.035C66.9026 67.667 66.0866 70.7525 66.0866 75.2915C66.0866 79.6265 66.9281 82.6355 68.6111 84.3185C70.2941 85.9505 73.3286 86.7665 77.7146 86.7665H102.501C109.539 86.7665 114.715 88.4495 118.03 91.8155C121.345 95.1305 123.003 100.307 123.003 107.345C123.003 114.332 121.345 119.508 118.03 122.874C114.715 126.189 109.539 127.847 102.501 127.847H77.4086Z"
        fill="none"
      />
    </svg>
  );
};

export default Logo;
